import { number2format } from 'function/convert';
import { RETURN_YN } from 'types/type';
import isEmpty from 'utils/isEmpty';

/**
 * Enter 키를 누른 경우 이벤트
 * @param {Object} event 이벤트
 * @param {Function} onKeyPress Enter 키를 누른 경우 이벤트
 * @example <Form.Control onKeyUp={event => onEnterKeyPress(event, onKeyPress)} />
 */
function onEnterKeyPress({ keyCode } = {}, onKeyPress) {
  if (keyCode === 13) {
    onKeyPress?.();
  }
}

/**
 * 입력 값 변경 시 이벤트
 * @param {Object} event 이벤트
 * @param {Function} setState 상태 설정 함수
 * @param {Object} [options] 옵션
 * @param {string} [options.convert] 변환할 타입
 * @param {string} [options.type] 구분
 * @param {string} [options.format] 구분(type)이 'number'인 경우 숫자 형식
 * @param {number} [options.max] 구분(type)이 'number'인 경우 최대 값
 * @example <Form.Control onChange={event => onInputChange(event, setState)} />
 */
function onInputChange(
  event = {},
  setState,
  { convert, type, format, max } = {}
) {
  const { target = {} } = event;
  const { checked, name, type: inputType } = target;

  let { value } = target;

  switch (inputType) {
    case 'checkbox':
      value = RETURN_YN[checked ? 'Y' : 'N'];

      break;

    default:
      if (type === 'number') {
        value = number2format(value, format, max);

        if (value === false) {
          return;
        }
      }
  }

  if (convert === 'number') {
    value = Number(value);
  }

  setState?.({ [name]: value });
}

/**
 * 목록 클릭 시 이벤트
 * @param {Object} event 이벤트
 * @param {Function} onClick 목록 클릭 시 이벤트
 * @example <tr onClick={event => onListClick(event, onClick)}>
 */
function onListClick({ target: { classList, parentNode } = {} } = {}, onClick) {
  let hasCursorPointer = classList?.contains?.('cursor-pointer');

  while (!hasCursorPointer && !isEmpty(parentNode)) {
    hasCursorPointer = parentNode.classList?.contains?.('cursor-pointer');
    parentNode = parentNode.parentNode;
  }

  // 'cursor-pointer' 클래스가 있는 경우
  if (hasCursorPointer) {
    // 목록 클릭 시 이벤트 실행
    onClick?.();
  }
}

export { onEnterKeyPress, onInputChange, onListClick };
